import { render, staticRenderFns } from "./AppLeftNav.vue?vue&type=template&id=46a7d515&scoped=true"
import script from "./AppLeftNav.vue?vue&type=script&lang=js"
export * from "./AppLeftNav.vue?vue&type=script&lang=js"
import style0 from "./AppLeftNav.vue?vue&type=style&index=0&id=46a7d515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a7d515",
  null
  
)

/* custom blocks */
import block0 from "./AppLeftNav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports